// extracted by mini-css-extract-plugin
export default {"title":"_0965100cd5","inner_title":"cff89b48d2","charge_btn":"f53db707f0"};